import styled, { css } from "styled-components";
import { upperMenuHeight } from "../../../common/parameters";

export const StyledLoader = styled.div`
    margin-top: 100px;
    ${p =>
        p.theme.sm.min(css`
            margin-top: calc((100vh - 150px) / 2);
        `)}
`;

export const PlayWrapper = styled.div`
    width: 100vw;
    height: calc(100vh - ${upperMenuHeight}px);
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: ${upperMenuHeight}px;
`;

export const ChangeOrientation = styled.h3`
    text-align: center;
    font-variant: normal;
    font-weight: 400;
    padding: 0 20px 20px;
`;

export const SuccessCompletion = styled.div`
    text-align: center;
    font-variant: normal;
    font-weight: 400;
`;

export const Description = styled.p`
    font-size: 16px;
    margin-top: 0;
`;

export const Privacy = styled.p`
    font-size: 12px;
`;